module.exports = __webpack_public_path__ + "img/icon13.b6432933.png";